// extracted by mini-css-extract-plugin
export default {"section":"Ns-z","inSectionButton":"Os-z","addressCard":"Ps-z","disabled":"Qs-z","cautionBox":"Rs-z","failureBox":"Ss-z","fade-out":"Ts-z","successBox":"Us-z"};